export const AssetCards = {
  cards: [],
  installments_text: [],
  enabled_cards_installments: [],
  min_price_cards_exception: {
    default_min_price_cards: null,
    card_items_min_price: null,
    card_items: [],
    card_subtitle: ''
  }
};
